export type VymirConfig = { origin: string; tenant: string; slug: string };

export const VYMIR_CONFIGURATOR_MAP: Record<string, VymirConfig> = {
  '7MQARAC4': {
    origin: 'http://localhost:5174',
    tenant: 'costco',
    slug: 'sofa-1'
  },
  PFFUR839: {
    origin: 'https://configurator.cgifurniture.com',
    tenant: 'costco',
    slug: 'sofa-1'
  }
};

export function getVymirConfigForNanoId(nanoId: string): VymirConfig | null {
  return VYMIR_CONFIGURATOR_MAP[nanoId] ?? null;
}
